import { instance } from "../axios";

export const getTemperatures = async (studyId) => {
  const response = await instance.get(
    studyId ? `/temperatures/study/${studyId}` : `/temperatures`,
  );
  return response.data;
};

export const getTemperaturesByStudy = async (studyId) => {
  const response = await instance.get(`/temperatures/study/${studyId}`);
  return response.data;
};
